import { Typography } from "@mui/material";
import { dateFormatter } from "components/helpers";

import React from "react";
import { Link } from "react-router-dom";
import { getFormattedDate } from "utils/helper";

export const columns = [
  {
    field: "patient_id",
    headerName: "ID",
    minWidth: 80,
  },
  {
    field: "first_name",
    headerName: "Patient Name",
    width: 200,
    renderCell: (e) => {
      return (
        <Link
          to={`/patients-details/${e.row.first_name}-${e.row.last_name}`}
          state={e.row}
        >
          <Typography color="primary">
            {e.row.first_name} {e.row.last_name}
          </Typography>
        </Link>
      );
    },
  },
  {
    field: "dob",
    headerName: "DOB",
    minWidth: 120,
    valueFormatter: (value) => {
      if (!value) {
        return;
      }
      return getFormattedDate(value);
    },
    valueGetter: dateFormatter,
  },

  {
    field: "gender",
    headerName: "Gender",
    minWidth: 100,
  },
  {
    field: "email",
    headerName: "Email",
    minWidth: 140,
  },
  {
    field: "address1",
    headerName: "Address",
    minWidth: 200,
    renderCell: (e) => (
      <div>
        {e.row.address1 || ""} {e.row.address2 || ""}
      </div>
    ),
  },
  {
    field: "blood_group",
    headerName: "Blood Group",
    minWidth: 100,
  },
  {
    field: "country",
    headerName: "Country",
    minWidth: 100,
  },
  {
    field: "phone_no_mobile",
    headerName: "Number",
    minWidth: 200,
    renderCell: (e) => {
      return (
        <Typography>
          {e.row?.phone_no_mobile && <>{e.row?.phone_no_mobile} </>}
          {e.row?.phone_no_home && <> {e.row?.phone_no_home} </>}
          {e.row?.phone_no_work && <> {e.row?.phone_no_work} </>}
        </Typography>
      );
    },
  },
];
